<script lang="ts">
    import PagePreviewColumn from "./PagePreviewColumn.svelte";
    import Krankenwagen from "../icons/KrankenwagenIcon.svelte";
    import Systeme from "../icons/SystemsIcon.svelte";
    import Funk from "../icons/FunkIcon.svelte";
    import Alarm from "../icons/AlarmIcon.svelte";
    import Reparaturen from "../icons/RepairIcon.svelte";
    import Server from "../icons/ServerIcon.svelte";
    import SystemsIcon from "../icons/SystemsIcon.svelte";
    import Container from "./Container.svelte";
    import { t } from "../helpers/translation";
    import EinsatznavigationIcon from "../icons/EinsatznavigationIcon.svelte";
    export let small: boolean = false;
    export let noborders: boolean = false;

    export let leitstellen: boolean = false;
    export let wachen_elw: boolean = false;
    export let digital_alarm: boolean = false;
    export let reparaturen: boolean = false;
    export let dienstleistungen: boolean = false;
    export let sprach_datenfunk: boolean = false;
    export let einsatznavigation: boolean = false;
    export let all_pages: boolean = false;

    if (all_pages) {
        leitstellen = true;
        wachen_elw = true;
        digital_alarm = true;
        reparaturen = true;
        dienstleistungen = true;
        sprach_datenfunk = true;
        einsatznavigation = true;
    }
</script>

<Container big>
    <div class="page-preview-container" class:small class:noborders>
        {#if leitstellen}
            <PagePreviewColumn
                icon={Systeme}
                heading={$t("pagepreviews.leitstellen.headline")}
                text={$t("pagepreviews.leitstellen.p")}
                href="loesungen/leitsysteme"
            />
        {/if}
        {#if wachen_elw}
            <PagePreviewColumn
                icon={Krankenwagen}
                heading={$t("pagepreviews.wachenelw.headline")}
                text={$t("pagepreviews.wachenelw.p")}
                href="loesungen/wachen-und-elw"
            />
        {/if}
        {#if einsatznavigation}
            <PagePreviewColumn
                icon={EinsatznavigationIcon}
                heading={$t("pagepreviews.einsatznavigation.headline")}
                text={$t("pagepreviews.einsatznavigation.p")}
                href="loesungen/einsatznavigation"
            />
        {/if}
        {#if sprach_datenfunk}
            <PagePreviewColumn
                icon={Funk}
                heading={$t("pagepreviews.sprachdaten.headline")}
                text={$t("pagepreviews.sprachdaten.p")}
                href="loesungen/sprach-und-datenfunk"
            />
        {/if}
        {#if digital_alarm}
            <PagePreviewColumn
                icon={Alarm}
                heading={$t("pagepreviews.digitalalarm.headline")}
                text={$t("pagepreviews.digitalalarm.p")}
                href="loesungen/digitale-alarmierung"
            />
        {/if}
        {#if reparaturen}
            <PagePreviewColumn
                icon={Reparaturen}
                heading={$t("pagepreviews.repair.headline")}
                text={$t("pagepreviews.repair.p")}
                href="loesungen/reparaturen"
            />
        {/if}
        {#if dienstleistungen}
            <PagePreviewColumn
                icon={Server}
                heading={$t("pagepreviews.itservice.headline")}
                text={$t("pagepreviews.itservice.p")}
                href="loesungen/it"
            />
        {/if}
    </div>
</Container>

<style lang="scss">
    @import "./src/vars";

    .page-preview-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        transform: translateX(-8px);
        overflow-x: hidden;
        margin-top: 8rem;

        @media (max-width: 1300px) {
            grid-template-columns: 1fr 1fr;
        }
        @media (max-width: 800px) {
            grid-template-columns: 1fr;
            max-width: 500px;
            margin-left: auto;
            margin-right: auto;
            :global(*) {
                text-align: center;
            }
        }
        margin-top: 4em;

        :global(.page-preview-column) {
            transform: translateX(4px);
        }
    }
</style>
